// extracted by mini-css-extract-plugin
export default {"appContainer":"setup_appContainer__iolE3"};